import React, { Component } from 'react';
import { translate } from 'react-i18next';

import {withRouter} from 'react-router-dom';
import ChallengeService from '../../services/ChallengeService.js';
import { connect } from 'react-redux';
import Objectives  from './Objectives.js';
import {initNavbarState} from 'actions/navbar.js';
import {fetchObjectives} from 'actions/objectives.js';
import {getObjectives} from 'reducers/objectives.js';
import defaultObjectiveImage from 'img/default-challenge-image.jpg';

class ObjectivesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false};
        this.onClickObjective= this.onClickObjective.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, title:this.props.t('Add New Goal'), menuEnable:false, backButtonEnable:true, rewardsEnable:false}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onClickObjective(objectiveId) {
        this.props.history.push('/objectives/' + objectiveId);
    }
    getObjectiveImageUrl(objective) {
        if(objective.image && (objective.image.sourceUrl||'').length>0) {
            return objective.image.sourceUrl;
        } else {
            return defaultObjectiveImage;
        }
    }

    render() {
        var t = this.props.t;
        var viewAll = {
            id:'all',
            title:t('View All Goals'),
        };

        return <Objectives objectives={this.props.objectives.concat(viewAll)} 
                           onClickObjective={this.onClickObjective}
                           getObjectiveImageUrl={this.getObjectiveImageUrl}
                           busy={this.state.busy} />;
    }

}


const mapStateToProps = (state) => {
    return {objectives:getObjectives(state.objectives)};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(fetchObjectives()),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('objectives')(ObjectivesContainer)));



// WEBPACK FOOTER //
// ./src/modules/objectives/ObjectivesContainer.js